import { render, staticRenderFns } from "./_ScheduleLabel.vue?vue&type=template&id=85e5c3b2"
import script from "./_ScheduleLabel.vue?vue&type=script&lang=ts"
export * from "./_ScheduleLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports